var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message.quickReply
    ? _c("div", [
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-2 mb-3" },
          [
            _vm._l(_vm.message.quickReply.items, function(item, index) {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm m-1",
                    class: item.style,
                    on: {
                      click: function($event) {
                        return _vm.checkMessage(item)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.text) + "\n      ")]
                )
              ]
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcc437b0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc437b0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/QuickReply.vue
// module id = 2233
// module chunks = 0